// extracted by mini-css-extract-plugin
export default {"main_data_show_up":"maindata_main_data_show_up__lU5+h","main_data_gap":"maindata_main_data_gap__vCuPN"};